import React from 'react';
import PropTypes from 'prop-types';

import deleteIcon from 'images/icons/invite/delete.svg';
import viewIcon from 'images/icons/invite/view.svg';
import { useContext } from './Context';
import CloseAction from './CloseAction';

export default function RowActions({ row }) {
  const { dispatch, actions } = useContext();

  const onRemoveItem = (e) => {
    swal(
      {
        title: '',
        text: 'Do you want to unassign the program?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        closeOnConfirm: true,
        closeOnCancel: true,
      },
      (isConfirm) => {
        if (isConfirm) {
          let el = e.target;
          while (el && el.tagName !== 'A') {
            el = el.parentNode;
          }

          el.innerHTML = '<i class="fa fa-spinner fa-spin"></i>';
          actions.remove(dispatch, row.id);
        }
      },
    );
  };

  return (
    <>
      {row.attributes.program_type === 'coaching_program' && (
      <a className="show-in-layer mr5" data-remote="true" data-type="html" href={`/admin/programs/description/${row.id}`}>
        <img src={viewIcon} alt="view" />
      </a>
      )}

      {row.attributes.possible_remove_assign && (
        <a className="mr5" onClick={onRemoveItem}>
          <img src={deleteIcon} alt="delete" />
        </a>
      )}

      <CloseAction row={row} />
    </>
  );
}

RowActions.propTypes = {
  row: PropTypes.object.isRequired,
};
